export enum AssessmentType {
  Unknown = 0,
  Approved = 1,
  Rejected = 2,
}
